
import gql from 'graphql-tag'

// """新建经销商(任何人)"""
export const createDealer = gql`
  mutation($code: String!, $input: NewDealerInput!) {
    createDealer(
      code: $code,
      input: $input
    ) {
      id
    }
  }
`
// """更新经销商(经销商)"""
export const updateDealer = gql`
  mutation($dealerId: Int!, $input: EditDealerInput!) {
    updateDealer(
      dealerId: $dealerId,
      input: $input
    ) {
      id
    }
  }
`

// 重置经销商密码
export const resetDealerPassword = gql`
  mutation($dealerId: Int!) {
    resetDealerPassword(dealerId: $dealerId)
  }
`
